import { Link } from 'react-router-dom';
import { useRef } from 'react';
import { inboxGeneratedMeta, INBOX_HOVER_READ_MS } from '../../utils/reportFormat';
import './report-downloads.css';

function statusLabel(item) {
  const status = item?.queue_status;
  if (status === 'queued') {
    return { className: 'inbox-pill inbox-pill-queued', text: 'Generating' };
  }
  if (status === 'failed') {
    return { className: 'inbox-pill inbox-pill-failed', text: 'Failed' };
  }
  if (status === 'ready') {
    return { className: 'inbox-pill inbox-pill-ready', text: 'Ready' };
  }
  return null;
}

/**
 * Shared header inbox (bell + downloads): unread rows, red mark, hover to mark read, View all.
 */
export default function HeaderInboxMenu({
  icon,
  iconAlt,
  title,
  items = [],
  count = 0,
  emptyText,
  viewAllTo,
  viewAllLabel,
  onOpenItem,
  onMarkRead,
  showStatus = false,
}) {
  const unreadCount = Number(count) || 0;
  const hoverTimers = useRef({});

  const clearHover = (id) => {
    if (hoverTimers.current[id]) {
      clearTimeout(hoverTimers.current[id]);
      delete hoverTimers.current[id];
    }
  };

  const handleMouseEnter = (item) => {
    if (!item?.id || item.queue_status === 'queued' || !onMarkRead) {
      return;
    }
    clearHover(item.id);
    hoverTimers.current[item.id] = setTimeout(() => {
      onMarkRead(item);
    }, INBOX_HOVER_READ_MS);
  };

  return (
    <li className="nav-item dropdown notify notify-inbox">
      <a
        className="nav-link dropdown-toggle"
        href="#"
        id={`${title.replace(/\s+/g, '-').toLowerCase()}-dropdown`}
        role="button"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        <img src={icon} width="20px" alt={iconAlt || title} />
        {unreadCount > 0 ? <span className="badge">{unreadCount > 9 ? '9+' : unreadCount}</span> : null}
      </a>
      <ul className="dropdown-menu inbox-menu" aria-labelledby={`${title.replace(/\s+/g, '-').toLowerCase()}-dropdown`}>
        <li>
          <h4 className="inbox-head">
            <span>{title}</span>
            {unreadCount > 0 ? <span className="inbox-head-count">{unreadCount}</span> : null}
          </h4>
        </li>
        <li className="inbox-list">
          {items.length === 0 ? (
            <p className="inbox-empty">{emptyText}</p>
          ) : (
            items.map((item) => {
              const pill = showStatus ? statusLabel(item) : null;
              const heading = item.report_name || item.title || title;
              const isDownload = showStatus && item.queue_status === 'ready' && item.url;
              const meta = inboxGeneratedMeta(item);
              const showUnreadDot = item.queue_status !== 'queued';
              return (
                <a
                  key={item.id || item.title}
                  className={`inbox-item is-unread ${item.queue_status === 'queued' ? 'is-queued' : ''} ${item.queue_status === 'failed' ? 'is-failed' : ''}`}
                  href={item.url || viewAllTo}
                  download={isDownload ? true : undefined}
                  onClick={(event) => onOpenItem && onOpenItem(event, item)}
                  onMouseEnter={() => handleMouseEnter(item)}
                  onMouseLeave={() => clearHover(item.id)}
                >
                  <span className="inbox-item-main">
                    <strong className="inbox-title">{heading}</strong>
                    <span className="inbox-note">{item.note}</span>
                    {(item.failure_reason || item.stuck_reason) ? (
                      <span className="inbox-reason">Reason: {item.failure_reason || item.stuck_reason}</span>
                    ) : null}
                    <span className="inbox-meta">
                      <span className="inbox-meta-text">
                        {meta.when ? <small className="inbox-time">{meta.when}</small> : null}
                        {meta.who ? <small className="inbox-who">Generated by {meta.who}</small> : null}
                      </span>
                      {pill ? <span className={pill.className}>{pill.text}</span> : null}
                    </span>
                  </span>
                  {showUnreadDot ? <span className="inbox-unread-dot" title="Unread" /> : null}
                </a>
              );
            })
          )}
        </li>
        <li>
          <Link className="inbox-footer" to={viewAllTo}>
            {viewAllLabel}
          </Link>
        </li>
      </ul>
    </li>
  );
}
